import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import firebase from 'firebase/app';
import 'firebase/auth'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor, /* { default global options } */)
import firebase_api from '@/firebase/firebase_api'
import tuto_api from '@/firebase/tuto_api'
import SLabel 			from '@/components/SLabel.vue'
import SElo 			from '@/components/SElo.vue'
import SDemo 			from '@/components/SDemo.vue'
import SSelect 			from '@/components/SSelect.vue'
import SButton 			from '@/components/SButton.vue'
import SArrow 			from '@/components/SArrow.vue'
import SCode 			from '@/components/SCode.vue'
import SModal 			from '@/components/SModal.vue'
import SInfo 			from '@/components/SInfo.vue'
import SZoom 			from '@/components/SZoom.vue'
import SConfirm 			from '@/components/SConfirm.vue'
import SInput 			from '@/components/SInput.vue'
import SInputSearch 			from '@/components/SInputSearch.vue'
import SSwitch 			from '@/components/SSwitch.vue'
import navbar 			from '@/components/MyNavbar.vue'
import navbarfooter			from '@/components/navbarfooter.vue'
import waiting			from '@/components/waiting.vue'
import SMsg			    from '@/components/SMsg.vue'
import SModalCode			    from '@/components/SModalCode.vue'
import vuefireTool 			from "@/firebase/vuefire";
import { firestorePlugin, rtdbPlugin } from 'vuefire'

import PincodeInput from 'vue-pincode-input';


import VueOffline from 'vue-offline'
import util 		  	from '@/util/tools'
import ImageUploader from "vue-image-upload-resize";
import SHelp 			from '@/components/SHelp.vue'
import SFil 			from '@/components/SFil.vue'
import SPdf 			from '@/components/SPdf.vue'
import SWindow 			from '@/components/SWindow.vue'
import VueYoutube from 'vue-youtube'
import SYouTube from '@/components/SYoutube.vue'
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs)
Vue.use(VueYoutube)
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, { siteKey: firebase_api.keys.siteKeyCaptchaV3,  autoHideBadge: false })

Vue.use(ImageUploader);
Vue.config.productionTip = false

Vue.use(firestorePlugin, { bindFnName: '$fsBind', unbindFnName: '$fsUnbind' })
// rename $rtdbBind -> $bind, $rtdbUnbind -> $unbind
Vue.use(rtdbPlugin, { bindFnName: '$bind', unbindFnName: '$unbind' })

Vue.use(VueOffline)


let app = '';

let deltaTimeStamp = null;



firebase_api.api.init(this);

const { v4: uuidv4 } = require('uuid');

/*
Vue.prototype.$uuid = function() {
  return UUID.v4();
}*/
vuefireTool.store.dispatch("setDeltaTimeStamp");
Vue.prototype.$getTimeStamp = function () {
  if (vuefireTool.store.getters.getDeltaTimeStamp==null) {
    vuefireTool.store.dispatch("setDeltaTimeStamp");
  }
  
    return vuefireTool.store.getters.getDeltaTimeStamp
}
Vue.prototype.$eloStart = function() {
  return 1199;
}
Vue.prototype.$sendRecaptcha = function(reloadCaptcha, recaptcha, fct) {
	return firebase_api.api.sendRecaptcha(reloadCaptcha, recaptcha, fct);
}
Vue.prototype.$getRole = function() {
  return vuefireTool.store.getters.getRole;
};
Vue.prototype.$StringToId = function(a) {
    return util.tools.StringToId(a);
};
Vue.prototype.$dateLimit = function (date, heure, delai) {
  var dateCalc = new Date(date);
                var heureDate = new Date ("0000-01-01 "+heure);
                dateCalc.setHours(heureDate.getHours()-delai, heureDate.getMinutes());
    return dateCalc;
};
Vue.prototype.$tuto = function (objectName, byId, route, icon, fct) {
  
  var activeDemo = vuefireTool.store.getters.getDemo.active;
  if (activeDemo) {
    if (icon=="times-circle") {
      fct(true);
    }
    else {
     
      var tutos = vuefireTool.store.getters.getTutos;
      vuefireTool.store.dispatch("setTutoBadButton", {badButton: false});
      tuto_api.object.tuto(objectName, byId, route, vuefireTool.store.getters.getDemo, tutos, (tuto)=>{
       
        if (tuto!=-1) {
           
            vuefireTool.store.dispatch("setTuto", {tuto: tuto});
            fct(true);
          }
          else {
            vuefireTool.store.dispatch("setTutoBadButton", {badButton: true});
            fct(false);
          }
      });
    }
  }
  else 
    fct(true);
};
Vue.prototype.$tutoBadButton = function () {
  var activeDemo = vuefireTool.store.getters.getDemo.active;
  if (activeDemo) {
    
    vuefireTool.store.dispatch("setTutoBadButton", {badButton: true});
  }
}
Vue.prototype.$arrowTuto = function (objectName, byId, route) {
  var activeDemo = vuefireTool.store.getters.getDemo.active;
  if (activeDemo) {
    var tutos = vuefireTool.store.getters.getTutos;
    return tuto_api.object.display(objectName, byId, route,vuefireTool.store.getters.getDemo, tutos, vuefireTool.store.getters.getUser);
  }
  else
    return false;
}
Vue.prototype.$user = function() {
    return firebase.auth().currentUser
};
Vue.prototype.$dateToYYYYMMDD = function (d) {
    var dateTemp = new Date(d);
    return d && new Date(dateTemp.getTime()-(dateTemp.getTimezoneOffset()*60*1000)).toISOString().split('T')[0];
};

Vue.prototype.$ANONYME = 'anonyme__';
Vue.prototype.$isAnonyme= function () {
      return (firebase.auth().currentUser.displayName == Vue.prototype.$ANONYME)
}
Vue.component("PincodeInput", PincodeInput)
Vue.component("SButton", SButton);
Vue.component("SCode", SCode);
Vue.component("SInput", SInput);
Vue.component("SInputSearch", SInputSearch);
Vue.component("navbar", navbar);
Vue.component("navbarfooter", navbarfooter);
Vue.component("SModal", SModal);
Vue.component("SInfo", SInfo);
Vue.component("SConfirm", SConfirm);
Vue.component("SHelp", SHelp);
Vue.component("SSwitch", SSwitch);
Vue.component("SWindow", SWindow);
Vue.component("SMsg", SMsg);
Vue.component("waiting", waiting);
Vue.component("SL", SLabel);
Vue.component("SZoom", SZoom);
Vue.component("SFil", SFil);
Vue.component("SPdf", SPdf);
Vue.component("SDemo", SDemo);
Vue.component("SElo", SElo);
Vue.component("SYouTube", SYouTube);
Vue.component("SModalCode", SModalCode);
Vue.component("SSelect", SSelect);
Vue.component("SArrow", SArrow);
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    
    let storeInst = vuefireTool.store;   
    storeInst.dispatch('init', ()=>{
     
        storeInst.dispatch("initLabel", ()=>{
          app = new Vue({
            router,
            store: storeInst,
            render: h => h(App)
          }).$mount('#app');
        })
      
    })
  }
})

;
